import { render, staticRenderFns } from "./Header-2.vue?vue&type=template&id=6c4c5711&scoped=true&"
import script from "./Header-2.vue?vue&type=script&lang=js&"
export * from "./Header-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c5711",
  null
  
)

export default component.exports